import React from "react";
import "./Contact.css";
import { Phone, Mail, MapPin } from "lucide-react";

function Contact() {
    return (
        <section className="contact-section">
            <h2 className="contact-title">Get Connected Today!</h2>
            <p className="contact-subtitle">
                Call us now for immediate installation and activation
            </p>

            <div className="contact-buttons">
                <a href="tel:7702935830" className="contact-btn">
                    <Phone size={18} className="contact-btn-icon" /> 7702935830
                </a>
                <a href="tel:8500168970" className="contact-btn">
                    <Phone size={18} className="contact-btn-icon" /> 8500168970
                </a>
            </div>

            <div className="contact-details">
                <span className="detail-item">
                    <Mail size={16} />
                    <a href="mailto:ritubroadband123@gmail.com" className="contact-link">
                        ritubroadband123@gmail.com
                    </a>
                </span>
                <span className="detail-divider">|</span>
                <span className="detail-item">
                    <MapPin size={16} />
                    <span>Achampet</span>
                </span>
            </div>
        </section>
    );
}

export default Contact;

